import { get } from '../utils/api'

export const fetchPortfolioData = async (limitCnt, imgType) => {
  try {
    const response = await get('/portfolio/list', {
      limitCnt: limitCnt, 
      imgType: imgType,
    });
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  };
};

export const fetchPartnerListData = async (pageIdx) => {
  try {
    const response = await get('/portfolio/partner/list', {
      pageIdx: pageIdx
    });
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  }
}

export const fetchPartnerDetailData = async (idx) => {
  try {
    const response = await get('/portfolio/partner/detail', {
      ptIdx: idx
    });
    return response;
  } catch (error) {
    return [];
  }
}

export const fetchGalleryListData = async (limitCnt, pageIdx) => {
  try {
    const response = await get('/portfolio/gallery/list', {
      limitCnt: limitCnt,
      pageIdx: pageIdx,
    });
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  }
}

export const fetchGalleryDetailData = async (idx) => {
  try {
    const response = await get('/portfolio/gallery/detail', {
      dgIdx: idx
    });

    const allListRes = await get(`/portfolio/gallery/all`);

    const images = [];
    const headerText = [];
    const contentText = [];

    images.push(response[0].DG_THUMBNAIL);
    response.forEach(row => {
      images.push(row.PF_PATH);
    });

    headerText.push('업체명');
    headerText.push('재질');
    headerText.push('주파수');
    headerText.push('특이사항');

    contentText.push(response[0].DG_COMPANY_NAME);
    contentText.push(response[0].DG_MATERIAL);
    contentText.push(response[0].DG_FREQUENCY);
    contentText.push(response[0].DG_NOTE);
    
    const allListInfo = allListRes.map(item => ({
      DG_IDX: item.DG_IDX,
      DG_THUMBNAIL: item.DG_THUMBNAIL
    }));

    return { 
      title: response[0].DG_TITLE,
      images: images,
      th: headerText,
      td: contentText,
      allListInfo : allListInfo,
    };
  } catch (error) {
    console.log(error);
    return [];
  }
}